module.exports = __webpack_public_path__ + "img/znjt.a9ef2944.png";